/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ActivityUpdate { 
    /**
     * Zadejte název aktivity.
     */
    title: string;
    /**
     * Zadejte podrobný popis aktivity.
     */
    description?: string;
    skills?: Array<string>;
    competencies?: Array<string>;
    literacies?: Array<string>;
    /**
     * Zaškrtněte, pokud je tato aktivita doporučená pro 1. úroveň.
     */
    isFirstLevelRecommended?: boolean;
    /**
     * Zaškrtněte, pokud je tato aktivita doporučená pro 2. úroveň.
     */
    isSecondLevelRecommended?: boolean;
    /**
     * Zaškrtněte, pokud je tato aktivita doporučená pro 3. úroveň.
     */
    isThirdLevelRecommended?: boolean;
    groupUuid: string;
    isFavorite?: boolean;
}